import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, isRef as _isRef, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { class: "prod-offer-old__wrap" };
const _hoisted_2 = { class: "prod-offer-old__main" };
const _hoisted_3 = ["onClick"];
const _hoisted_4 = {
    key: 0,
    class: "offer-teaser__cover"
};
const _hoisted_5 = {
    key: 1,
    class: "offer-teaser__cover offer-teaser__cover--blank"
};
const _hoisted_6 = { class: "offer-teaser__name" };
const _hoisted_7 = { class: "offer-teaser__cart" };
const _hoisted_8 = { class: "offer-teaser__prices" };
const _hoisted_9 = {
    key: 0,
    class: "offer-teaser__prices-changes"
};
const _hoisted_10 = { class: "offer-teaser__price-discount" };
const _hoisted_11 = { class: "offer-teaser__price-old" };
const _hoisted_12 = { class: "offer-teaser__price-new" };
const _hoisted_13 = { class: "offer-teaser__btn" };
const _hoisted_14 = ["onClick"];
const _hoisted_15 = { class: "btn__icon" };
const _hoisted_16 = {
    key: 0,
    class: "prod-offer-old__bottom"
};
const _hoisted_17 = { class: "prod-offer-old__parts" };
const _hoisted_18 = {
    type: "button",
    class: "btn btn--2 btn--m btn--black win",
    "data-act": "bnpl_info"
};
const _hoisted_19 = { class: "btn__icon" };
import { computed, inject, ref, useTemplateRef, watch } from "vue";
import handleAddToCartButtonClick from "../../../../components/product/add_to_cart";
import Sprite from "../../../../components/Sprite.vue";
import Picture from "../../../../components/Picture.vue";
import OfferTypeTabs from "./OfferTypeTabs.vue";
import Price from "../../../../components/Price.vue";
import Icon from "../../../../components/Icon.vue";
import PreOrder from "../../components/PreOrder.vue";
import HintTooltip from "../../components/HintTooltip.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'LegacyOfferList',
    props: {
        product: { type: Object, required: true },
        types: { type: Array, required: true },
    },
    setup(__props) {
        const props = __props;
        function inCart(offerId) {
            return cartOffers.value.includes(offerId);
        }
        const wrapper = ref();
        const activeType = inject('type');
        const activeOffer = inject('offer');
        const interacted = inject('interacted');
        const offers = computed(() => {
            let offers;
            if (!activeType.value) {
                offers = props.product.offers.sort((a, b) => {
                    return props.types.findIndex(t => a.type === t.id) - props.types.findIndex(t => b.type === t.id);
                });
            }
            else {
                offers = props.product.offers.filter(offer => { var _a; return offer.type === ((_a = activeType.value) === null || _a === void 0 ? void 0 : _a.id); });
            }
            offers = offers.map(o => (Object.assign(Object.assign({}, o), { title: o.title.replace(/\s*(тестер|refill|сэмпл)/ig, '') })));
            if (!activeOffer.value) {
                return offers;
            }
            if (!offers.find(o => o.id === activeOffer.value.id)) {
                activeOffer.value = null;
                return offers;
            }
            return offers;
        });
        const cartOffers = inject('cart');
        const listElement = useTemplateRef('listElement');
        if (!interacted.value) {
            activeType.value = null;
        }
        watch(activeType, () => setTimeout(() => listElement.value && listElement.value.scrollTo({ top: 0, behavior: "instant" })));
        function onclick(offer) {
            interacted.value = true;
            activeOffer.value = offer;
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: "prod-offer-old",
                ref_key: "wrapper",
                ref: wrapper
            }, [
                _createVNode(OfferTypeTabs, {
                    "base-url": __props.product.url,
                    types: __props.types,
                    modelValue: _unref(activeType),
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => (_isRef(activeType) ? (activeType).value = $event : null))
                }, null, 8 /* PROPS */, ["base-url", "types", "modelValue"]),
                _cache[13] || (_cache[13] = _createTextVNode()),
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("ul", {
                            class: "prod-offer-old__list",
                            ref_key: "listElement",
                            ref: listElement
                        }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(offers.value, (offer) => {
                                var _a;
                                return (_openBlock(), _createElementBlock("li", {
                                    class: "prod-offer-old__item",
                                    key: offer.id
                                }, [
                                    _createElementVNode("div", {
                                        class: _normalizeClass(["offer-teaser", { 'offer-teaser--highlighted': _unref(interacted) && offer.id === ((_a = _unref(activeOffer)) === null || _a === void 0 ? void 0 : _a.id) }]),
                                        onClick: ($event) => (onclick(offer))
                                    }, [
                                        (offer.image)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                                _createVNode(Picture, {
                                                    picture: offer.image.tiny,
                                                    fill: "",
                                                    lazy: false
                                                }, null, 8 /* PROPS */, ["picture"])
                                            ]))
                                            : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                                _createVNode(Sprite, {
                                                    name: "bottle",
                                                    size: 32
                                                })
                                            ])),
                                        _cache[7] || (_cache[7] = _createTextVNode()),
                                        _createElementVNode("div", _hoisted_6, [
                                            _createTextVNode(_toDisplayString(offer.title) + " ", 1 /* TEXT */),
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(offer.distinction.filter(d => !['тестер', 'сэмпл', 'refill'].includes(d)), (distinction) => {
                                                return (_openBlock(), _createElementBlock("span", null, _toDisplayString(distinction), 1 /* TEXT */));
                                            }), 256 /* UNKEYED_FRAGMENT */)),
                                            _cache[1] || (_cache[1] = _createTextVNode()),
                                            (offer.tester)
                                                ? (_openBlock(), _createBlock(HintTooltip, {
                                                    key: 0,
                                                    message: "тестер",
                                                    "button-class": "offer-teaser__description",
                                                    inline: "",
                                                    tester: offer.tester,
                                                    teleport: wrapper.value
                                                }, null, 8 /* PROPS */, ["tester", "teleport"]))
                                                : _createCommentVNode("v-if", true),
                                            _cache[2] || (_cache[2] = _createTextVNode()),
                                            (offer.refill)
                                                ? (_openBlock(), _createBlock(HintTooltip, {
                                                    key: 1,
                                                    message: "refill",
                                                    "button-class": "offer-teaser__description",
                                                    inline: "",
                                                    refill: offer.refill,
                                                    teleport: wrapper.value
                                                }, null, 8 /* PROPS */, ["refill", "teleport"]))
                                                : _createCommentVNode("v-if", true),
                                            _cache[3] || (_cache[3] = _createTextVNode()),
                                            (offer.sample)
                                                ? (_openBlock(), _createBlock(HintTooltip, {
                                                    key: 2,
                                                    message: "сэмпл",
                                                    "button-class": "offer-teaser__description",
                                                    inline: "",
                                                    sample: offer.sample,
                                                    teleport: wrapper.value
                                                }, null, 8 /* PROPS */, ["sample", "teleport"]))
                                                : _createCommentVNode("v-if", true)
                                        ]),
                                        _cache[8] || (_cache[8] = _createTextVNode()),
                                        _createElementVNode("div", _hoisted_7, [
                                            _createElementVNode("div", _hoisted_8, [
                                                (offer.oldPrice)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                                        _createElementVNode("div", _hoisted_10, "-" + _toDisplayString(offer.discount) + "%", 1 /* TEXT */),
                                                        _cache[4] || (_cache[4] = _createTextVNode()),
                                                        _createElementVNode("div", _hoisted_11, [
                                                            _createVNode(Price, {
                                                                amount: offer.oldPrice
                                                            }, null, 8 /* PROPS */, ["amount"])
                                                        ])
                                                    ]))
                                                    : _createCommentVNode("v-if", true),
                                                _cache[5] || (_cache[5] = _createTextVNode()),
                                                _createElementVNode("div", _hoisted_12, [
                                                    _createVNode(Price, {
                                                        amount: offer.price
                                                    }, null, 8 /* PROPS */, ["amount"])
                                                ])
                                            ]),
                                            _cache[6] || (_cache[6] = _createTextVNode()),
                                            _createElementVNode("div", _hoisted_13, [
                                                _createElementVNode("button", {
                                                    type: "button",
                                                    class: "btn btn--2 btn--m btn--black btn--icon",
                                                    onClick: ($event) => (_unref(handleAddToCartButtonClick)(offer.id)),
                                                    title: "Добавить в корзину"
                                                }, [
                                                    _createElementVNode("span", _hoisted_15, [
                                                        _createVNode(Icon, {
                                                            name: inCart(offer.id) ? 'add' : 'cart'
                                                        }, null, 8 /* PROPS */, ["name"])
                                                    ])
                                                ], 8 /* PROPS */, _hoisted_14)
                                            ])
                                        ])
                                    ], 10 /* CLASS, PROPS */, _hoisted_3)
                                ]));
                            }), 128 /* KEYED_FRAGMENT */))
                        ], 512 /* NEED_PATCH */),
                        _cache[9] || (_cache[9] = _createTextVNode()),
                        (_unref(activeType) && _unref(activeType).disabled)
                            ? (_openBlock(), _createBlock(PreOrder, {
                                key: 0,
                                "product-id": __props.product.id,
                                type: _unref(activeType)
                            }, null, 8 /* PROPS */, ["product-id", "type"]))
                            : _createCommentVNode("v-if", true)
                    ]),
                    _cache[12] || (_cache[12] = _createTextVNode()),
                    (offers.value.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                            _createElementVNode("div", _hoisted_17, [
                                _createElementVNode("button", _hoisted_18, [
                                    _createElementVNode("span", _hoisted_19, [
                                        _createVNode(Icon, {
                                            name: "parts",
                                            size: 20
                                        })
                                    ]),
                                    _cache[10] || (_cache[10] = _createTextVNode()),
                                    _cache[11] || (_cache[11] = _createElementVNode("span", { class: "btn__label" }, "Оплата частями", -1 /* HOISTED */))
                                ])
                            ])
                        ]))
                        : _createCommentVNode("v-if", true)
                ])
            ], 512 /* NEED_PATCH */));
        };
    }
});
